var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "loading-animation",
      class: { opaque: _vm.open, displayed: _vm.isDisplayed },
      attrs: { id: "loader" }
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "message" }, [_vm._t("default")], 2)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dots" }, [
      _c("div", { staticClass: "dot dot-1" }),
      _vm._v(" "),
      _c("div", { staticClass: "dot dot-2" }),
      _vm._v(" "),
      _c("div", { staticClass: "dot dot-3" }),
      _vm._v(" "),
      _c("div", { staticClass: "dot dot-4" }),
      _vm._v(" "),
      _c("div", { staticClass: "dot dot-5" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }